import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';


export class EmailDefaultData extends BaseModel implements Deserializable {

  ownerUid: string;
  language: string;
  fromEmail: string;
  fromName: string;
  toEmail: string;
  ccEmail: string;
  replyToEmail: string;
  subject: string;
  message: string;
  
  //   class EmailDefaultData {
  //     String ownerUid;
  //     String language;
  // tu passagli la lingua del webadmin
  //     String fromEmail;
  //     String fromName;
  //     String toEmail;
  //     String ccEmail;
  //     String replyToEmail;
  //     String subject;
  //     String message;
  // }

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    return this;
  }
}
